import React, { useState } from "react";
import FormInputs from "../../../../components/UI/FormInputs";
import LeftRightInput from "../../Forms/LeftRight";
import NormalAbnormal from "../../Forms/NormalAbnormal";
import PositiveNegative from "../../Forms/PositiveNegative";
import RangeOfMotion from "../../Forms/RangeOfMotion";
import DropDown from "../../Forms/DropDown";
import Exercise from "../../Forms/Exercise";
import CustomMatrix from "../../Forms/CustomMatrix";

const ExamTableForm = ({
  fields,
  sectionRefs,
  collapseRefs,
  fieldRefs,
  formState,
  setFormState,
  setValidation,
  validation,
  handleChange,
  handleSubmit,
  item,
  idx,
  setSectionRef,
  selectedTab
}) => {
  const [normalSelectedId, setNormalSelectedId] = useState("");
  const [checked, setChecked] = useState(false);
  const handleSetAllToNormal = () => {
    console.log("all normal clicked");
    const updatedFormState = { ...formState };

    item.fields.forEach((field) => {
      const { input_type, has_options, options } = field.field_type || {};

      // For fields with options like RADIO or CHECKBOX
      if (has_options && Array.isArray(field.options)) {
        const normalOpt = field.options.find(
          (opt) =>
            opt.value?.toLowerCase() === "normal" ||
            opt.value?.toLowerCase() === "negative"
        );

        if (normalOpt) {
          if (input_type === "SINGLE_SELECT") {
            updatedFormState[field.id] = normalOpt.id;
          } else if (input_type === "MULTI_SELECT") {
            updatedFormState[field.id] = [normalOpt.id];
          }
        }
      }

      // if (input_type === "NORMAL_ABNORMAL") {
      //   updatedFormState[field.id] = "NORMAL";
      // }

      // if (input_type === "POSITIVE_NEGATIVE") {
      //   updatedFormState[field.id] = "NEGATIVE";
      // }

      // if (input_type === "LEFT_RIGHT_BILATERAL") {
      //   updatedFormState[field.id] = {
      //     left: "NORMAL",
      //     right: "NORMAL",
      //   };
      // }

      // if (input_type === "RANGE_OF_MOTION") {
      //   updatedFormState[field.id] = field.options?.map(() => ({
      //     min_value: "0",
      //     max_value: "0",
      //   })) || [];
      // }
    });

    setFormState(updatedFormState);
  };

  return (
    <>
      <div className="card m-2" key={idx} ref={setSectionRef}>
        <a
          href={`#accordion-${idx}`}
          className="d-block card-header sh_accordionheader accordion-button collapsed"
          data-bs-toggle="collapse"
          role="button"
          aria-expanded="false"
          aria-controls={`accordion-${idx}`}
          onClick={() => setValidation({})}
        >
          <h6 className="m-0 text-md">{item.name}</h6>
        </a>

        <div
          className="accordion-collapse collapse show"
          id={`accordion-${idx}`}
          ref={(el) => {
            if (el) collapseRefs.current[item.emr_form_id] = el;
          }}
          onTransitionEnd={(e) => {
            if (
              e.propertyName === "height" &&
              !e.target.classList.contains("show")
            ) {
              setValidation({});
            }
          }}
        >
          <div className="card-body sh_emrtablecardbody">
            <div className="row">
              <div className="col-12">
              {(selectedTab === "History" || selectedTab === "Examination") && (
                  <span
                    className="sh_emr_roundbadge ml-1  chart"
                    onClick={handleSetAllToNormal}
                  >
                    N
                  </span>
                )}
                {/* <a
                  className="badge bg-blue-soft text-light cursor-pointer custom-btn mb-2"
                  onClick={handleSetAllToNormal}
                >
                  Set all to Normal
                </a> */}
                <table
                  className="table dataTable sh_emrtable table-bordered nowrap my-0 mt-2"
                  width="100%"
                  cellSpacing="0"
                  style={{ width: "100%" }}
                >
                  <tbody>
                    {item.fields.map((field, fIdx) => {
                      const fieldRef = (el) => {
                        if (el) {
                          fieldRefs.current[field.id] = el;
                        }
                      };

                      const { input_type, has_options } =
                        field.field_type || {};
                      const showOptions = has_options === 1;

                      return (
                        <tr key={fIdx} ref={fieldRef}>
                          {input_type == "RANGE_OF_MOTION" || input_type == "EXERCISE"  ? (
                            <td className="w-25 ">
                              <div className="d-flex align-items-center">
                                <h6 className="text-sm mb-0">
                                  {field.label}
                                  {/* {field.is_required && <span className="text-danger">*</span>} */}{" "}
                                </h6>
                                {/* {field.is_required && <span className="text-danger">*</span>} */}{" "}
                                <span
                                  className={`sh_emr_roundbadge ml-2 ${
                                    normalSelectedId === field.id && checked
                                      ? "normal"
                                      : "inactive"
                                  }`}
                                  title="All Normal"
                                  onClick={() => {
                                    setNormalSelectedId(field.id);
                                    if (normalSelectedId == field.id) {
                                      setChecked((prev) => !prev); // toggle checked state
                                    } else {
                                      setChecked(true); // always set to true when selecting a new field
                                    }
                                  }}
                                >
                                  N
                                </span>
                              </div>
                            </td>
                          ) : (
                            <td className="w-25">
                              <div className='w-100 d-flex align-items-center'>
                              {field.label}
                                 {/* {field.is_required && <span className="text-danger">*</span>} */}
                                 {field.is_required ? <span className="text-danger">*</span> : null}
                              </div>
                            
                            </td>
                          )}
                          {/* <td className="w-25">
                            {field.label}

                          </td> */}

                          <td className="w-75">
                            {/* TEXT_FIELD / TEXT_AREA / DATE */}
                            {["TEXT_FIELD", "TEXT_AREA", "DATE"].includes(
                              input_type
                            ) &&
                              !showOptions && (
                                <div className="form-group w-100 mb-0">
                                  <FormInputs
                                    type={
                                      input_type === "TEXT_AREA"
                                        ? "TextArea"
                                        : input_type === "DATE"
                                        ? "Date"
                                        : "TextInput"
                                    }
                                    name={`field-${field.id}`}
                                    className={
                                      input_type === "TEXT_AREA"
                                        ? "form-control"
                                        : "form-control form-control-solid"
                                    }
                                    value={formState[field.id] || ""}
                                    rows={input_type === "TEXT_AREA" ? 6 : 1}
                                    changeHandler={(val, { e }) => {
                                      const finalVal =
                                        input_type === "DATE"
                                          ? typeof val === "string"
                                            ? val
                                            : String(val)
                                          : val;
                                      handleChange(field.id, finalVal);
                                    }}
                                  />
                                </div>
                              )}

                            {/* SINGLE_SELECT / MULTI_SELECT */}
                            {["SINGLE_SELECT", "MULTI_SELECT"].includes(
                              input_type
                            ) &&
                              showOptions && (
                                <div className="sh_tablecolumn">
                                  {field.options.map((opt) => {
                                    const isSelected =
                                      input_type === "SINGLE_SELECT"
                                        ? String(formState[field.id]) ===
                                          String(opt.id)
                                        : (formState[field.id] || [])
                                            .map(String)
                                            .includes(String(opt.id));

                                    return (
                                      <div
                                        key={opt.id}
                                        className="form-group sh_emrtableformgroup mb-0"
                                      >
                                        <FormInputs
                                          id={`opt-${field.id}-${opt.id}`}
                                          type={
                                            input_type === "SINGLE_SELECT"
                                              ? "Radio"
                                              : "Checkbox"
                                          }
                                          name={`field-${field.id}`}
                                          className=""
                                          value={isSelected}
                                          changeHandler={(val, { e }) => {
                                            handleChange(
                                              field.id,
                                              opt.id,
                                              input_type === "MULTI_SELECT",
                                              input_type === "SINGLE_SELECT"
                                            );
                                          }}
                                        />

                                        <label
                                          // className="formlabel mb-0"
                                          htmlFor={`opt-${field.id}-${opt.id}`}
                                        >
                                          {opt.value}
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}

                            {input_type == "NORMAL_ABNORMAL" ? (
                              <NormalAbnormal
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                              />
                            ) : (
                              ""
                            )}

                            {input_type == "LEFT_RIGHT_BILATERAL" ? (
                              <LeftRightInput
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                              />
                            ) : (
                              ""
                            )}

                            {input_type == "POSITIVE_NEGATIVE" ? (
                              <PositiveNegative
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                              />
                            ) : (
                              ""
                            )}
                            {input_type == "RANGE_OF_MOTION" ? (
                              <RangeOfMotion
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                                normalSelectedId={normalSelectedId}
                                checked={checked}
                                setNormalSelectedId={setNormalSelectedId}
                                setChecked={setChecked}
                              />
                            ) : (
                              ""
                            )}
                            {input_type == "EXERCISE" ? (
                              <Exercise
                                field={field}
                                setFormState={setFormState}
                                formState={formState}
                                value={formState[field.id]}
                                isExam={true}
                                normalSelectedId={normalSelectedId}
                                checked={checked}
                                setNormalSelectedId={setNormalSelectedId}
                                setChecked={setChecked}
                              />
                            ) : (
                              ""
                            )}
                            {  input_type=='DROP_DOWN'?
                              <DropDown
                                  field={field}
                                  setFormState={setFormState}
                                  handleChange={handleChange}
                                  formState={formState}
                                  value={formState[field.id]}
                                  normalSelectedId={normalSelectedId}
                                  checked={checked}
                                  setNormalSelectedId={setNormalSelectedId}
                                  setChecked={setChecked}
                                  tableView={true}
                                  />
                                  :""}
                            {input_type == 'CUSTOM_MATRIX' ?
                                <CustomMatrix
                                  key={`${field.id}-${field.column_header || ''}`}
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  isExam={true}
                                />
                              :
                              ""
                            }
                            {validation[field.id] && (
                              <div className="text-danger small mt-1">
                                {validation[field.id]}
                              </div>
                            )}
                            
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card-footer p-1 d-flex justify-content-center">
            <button
              className="btn btn-primary"
              onClick={async () => {
                const success = await handleSubmit(item.emr_form_id, item);

                if (success) {
                  const el = collapseRefs.current[item.emr_form_id];
                  if (el && window.bootstrap?.Collapse) {
                    const collapseInstance =
                      window.bootstrap.Collapse.getOrCreateInstance(el);
                    collapseInstance.hide();
                  }
                }
              }}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamTableForm;
